// Check if live chat is available (9am-5pm EST)
export function isChatAvailable(): boolean {
  const now = new Date();
  
  // Convert to EST (UTC-5 or UTC-4 during DST)
  const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const hours = estTime.getHours();
  
  // Check if between 9am and 5pm EST
  return hours >= 9 && hours < 17;
}

export function getChatStatusMessage(): string {
  if (isChatAvailable()) {
    return "Live chat is available now (9AM-5PM EST)";
  }
  
  const now = new Date();
  const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const hours = estTime.getHours();
  
  if (hours < 9) {
    return `Chat will be available at 9:00 AM EST`;
  }
  return `Chat will be available tomorrow at 9:00 AM EST`;
}
